import { gql } from "@apollo/client";

// Define the GraphQL query
export const GET_FEATURES_QUERY = gql`
  query GetFeatures($categoryId: Int!) {
    getFeatures(categoryId: $categoryId) {
      attribute_id
      attribute_code
      frontend_label
      is_required
      input_type
      options {
        option_id
        swatch
        value
      }
    }
  }
`;
